import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import AppWithStoreAndIntProvider from './components/app/App.component';

const renderApp = () => {
  createRoot(document.getElementById('app')).render(<AppWithStoreAndIntProvider />);
};

if (
  process.env.LOG_A11Y === 'true'
  && process.env.NODE_ENV !== 'production'
) {
  import('react-axe').then(axe => {
    axe.default(React, ReactDOM, 1000);
    renderApp();
  });
} else {
  renderApp();
}
